import { capitalize } from 'lodash';
import React, { HTMLAttributes, ImgHTMLAttributes } from 'react';
import AlbumsPlayButton from '../AlbumsPlayButton/AlbumsPlayButton';
import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '#/router/routes';
import useDeviceId from '#/hooks/useDeviceId';
import ApiManager from '#/services/api/ApiManager';
import { spotifyApiConfig } from '#/utils/constants';
import useProtectedSpotify from '#/hooks/useProtectedAxios';

interface IProperties {
  id: string;
  uri: string;
  image: ImgHTMLAttributes<HTMLImageElement>['src'];
  albumType: string;
  name: string;
  releaseYear: number;
  numberOfSongs: number;
  isFavorite: boolean;
  onClickFavorite: HTMLAttributes<HTMLAnchorElement>['onClick'];
}

const AlbumBanner = (properties: IProperties) => {
  const {
    id,
    uri,
    image,
    albumType,
    name,
    releaseYear,
    numberOfSongs,
    isFavorite,
    onClickFavorite,
  } = properties;

  const { retrieveDeviceId } = useDeviceId();

  const protectedSpotify = useProtectedSpotify();

  const handleClickPlay = async () => {
    const apiManager = new ApiManager(spotifyApiConfig, protectedSpotify);

    const response = await apiManager.replaceEntity(
      'playerPlay',
      '',
      {
        context_uri: uri,
      },
      {
        device_id: retrieveDeviceId(),
      }
    );
    if ('error' in response) {
      // TODO: handle error
      // eslint-disable-next-line no-console
      console.log('Cant reproduce');
    }
  };
  return (
    <div className="flex gap-6 p-2 pb-8 pt-10">
      <img className=" w-[136px] aspect-square" src={image} alt="" />
      <div className="flex flex-col justify-between">
        <Link to={`${ROUTE_NAMES.ALBUM}/${id}`}>
          <span className=" text-[32px] font-bold tracking-tighter hover:cursor-pointer hover:underline">
            {name}
          </span>
        </Link>
        <span className=" text-sm text-theme-light-gray">
          {capitalize(albumType)} • {releaseYear} •{' '}
          {`${numberOfSongs} song${numberOfSongs > 1 ? 's' : ''}`}
        </span>
        <div className="flex gap-4 items-center">
          <AlbumsPlayButton onClick={handleClickPlay} />
          <span
            className={`material-icons text-[28px] cursor-default ${
              isFavorite
                ? 'text-theme-green'
                : 'text-theme-light-gray hover:text-theme-white'
            } `}
            onClick={onClickFavorite}
          >
            {isFavorite ? 'favorite' : 'favorite_border'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AlbumBanner;
